export function AppointmentSkeleton() {
  return (
    <div className="animate-pulse p-4 border-b">
      <div className="flex items-center gap-4">
        <div className="w-32 h-4 bg-gray-200 rounded" />
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <div className="w-40 h-4 bg-gray-200 rounded" />
            <div className="w-32 h-4 bg-gray-200 rounded" />
          </div>
          <div className="flex gap-4">
            <div className="w-20 h-3 bg-gray-200 rounded" />
            <div className="w-16 h-3 bg-gray-200 rounded" />
            <div className="w-24 h-3 bg-gray-200 rounded" />
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-gray-200 rounded-full" />
          <div className="text-right">
            <div className="w-32 h-4 bg-gray-200 rounded mb-1" />
            <div className="w-24 h-3 bg-gray-200 rounded" />
          </div>
          <div className="w-20 h-6 bg-gray-200 rounded-full" />
        </div>
      </div>
    </div>
  );
}
